import type { GetPlansQuery } from '@frameio/graphql-client/generated';

type PlanFromQuery = NonNullable<
  NonNullable<GetPlansQuery['account']>['plans']
>[number];
type upgradedTier = 'FREE' | 'PRO' | 'TEAM' | 'ENTERPRISE';

/**
 * @desc shared util for receiving the next upgraded plan
 * @param plans {Array<PlanFromQuery>}
 * @param tier {string}
 * @param upgradeTier {boolean}
 * @returns {PlanFromQuery}
 */
export const getUpgradedPlan = (
  plans: Array<PlanFromQuery>,
  tier: string,
  upgradedTier?: upgradedTier
) => {
  if (!plans) return null;

  if (upgradedTier) {
    return plans.find((plan) => plan.tier === upgradedTier);
  }

  const currentIndex = plans.findIndex((item) => item.tier === tier);

  if (currentIndex === -1) {
    return null;
  }

  const nextIndex = currentIndex + 1;

  // If already at the highest tier, return null (no upgrade available)
  if (nextIndex >= plans.length) {
    return null;
  }

  return plans[nextIndex];
};
